import styled from "styled-components";

export default c => styled(c)`
  .blocked-text {
    color: red;
    font-weight: 800;
  }

  .active-text {
    color: #00b817;
    font-weight: 800;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/support/company/style.js